// eventBus.js
import { ref } from "vue";

// 创建一个 ref 作为事件总线
const eventBus = ref({});

// 提供事件监听方法
export const onEvent = (eventName, callback) => {
  if (!eventBus.value[eventName]) {
    eventBus.value[eventName] = [];
  }
  eventBus.value[eventName].push(callback);
};

// 提供事件触发方法
export const emitEvent = (eventName, ...args) => {
  if (eventBus.value[eventName]) {
    eventBus.value[eventName].forEach((callback) => callback(...args));
  }
};

// 提供事件移除方法
export const offEvent = (eventName, callback) => {
  if (eventBus.value[eventName]) {
    eventBus.value[eventName] = eventBus.value[eventName].filter(
      (cb) => cb !== callback
    );
  }
};
